import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import HireSidebar from "../HireSidebar/HireSidebar";

const HireLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<HireSidebar />}>{children}</NavigationBar>
);

export default HireLayout;
